if (!customElements.get("message-modal")) {
  class MessageModal extends HTMLElement {
    constructor() {
      super();

      this.handleToggleRef = this.handleToggle.bind(this);
    }

    handleToggle() {
      this.classList.toggle("is-open");
    }

    disconnectedCallback() {
      document.removeEventListener("cart:message-toggle", this.handleToggleRef);
    }

    connectedCallback() {
      document.addEventListener("cart:message-toggle", this.handleToggleRef);
    }
  }

  customElements.define("message-modal", MessageModal);
}
